<template>
  <div class="page-wrapper" >
    <table-list
      :columns="columns" :data="dataList" :loading="loading" :total="total" :current="current"
      @change-page="changePage"
    ></table-list>
    <!--<Table :columns="columns" :data="dataList"></Table>-->
  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import {housebuildinglist} from "../../../../../api/project";

  export default {
    name: "BuildInfo",
    props:{
      projectFid: {
        type: String,
        default: null
      }
    },
    watch:{
      projectFid(){
        this.housebuildinglist()
      }
    },
    components:{
      TableList,
    },
    data(){
      return {
        page:1,
        limit:10,
        loading:false,
        current:1,
        total:0,
        columns: [
          {
            title: "楼栋名称",
            key: "buildingName",
            align: "center"
          },
          {
            title: "楼体结构",
            key: "buildingStructure",
            align: "center"
          },
          {
            title: "建成年代",
            key: "buildingFinishYear",
            align: "center"
          },
          {
            title: "产权类型",
            key: "projectPropertyType",
            align: "center"
          },
          {
            title: "层高",
            key: "buildingFloorheight",
            align: "center"
          },
          {
            title: "楼层数",
            key: "buildingFloornumber",
            align: "center"
          },
          // {
          //   title: "房间数",
          //   key: "",
          //   align: "center"
          // },
          {
            title: "朝向",
            key: "buildingDirection",
            align: "center"
          },
          {
            title: "建筑面积",
            key: "buildingArea",
            align: "center"
          },
          {
            title: "外墙面积",
            key: "buildingOutsidearea",
            align: "center"
          },
          {
            title: "电梯数",
            key: "buildingElevatornumber",
            align: "center"
          },
          {
            title: "楼梯数",
            key: "buildingStairnumber",
            align: "center"
          },
        ],
        dataList:[]

      }
    },
    methods:{
      changePage(n){
        this.current=n
        this.page=n
        this.housebuildinglist()
      },
      housebuildinglist(){
        if(!this.projectFid){
          return
        }
        var params={
          projectFid:this.projectFid,
          page:this.page,
          limit:this.limit
        }
        housebuildinglist(params).then(res=>{
          this.dataList=res.data.houseBuildingList
          this.total=res.data.total
        })
      }
    },
    created(){
      this.housebuildinglist()
    }
  }
</script>

<style scoped>
  .page-wrapper{
    padding-top: 0;
  }

</style>
